<template>
  <div class="flex flex-col bg-white rounded-sm text-gray mx-2 my-3 p-2">
    <div class="px-4 mb-2">
      <span class="title">Notifications</span>
    </div>
    <div class="mb-4 border-b border-gray-200">
      <nav class="flex space-x-6 px-4" aria-label="Tabs">
        <div :class="[currentRoute === 'statistics' ? 'border-primary text-primary' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300', 'whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm flex items-center space-x-2 transition cursor-pointer']" @click="select('statistics')">
        Statistics
        </div>
        <div :class="[currentRoute === 'all' ? 'border-primary text-primary' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300', 'whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm flex items-center space-x-2 transition cursor-pointer']" @click="select('all')">
        All notifications
        </div>
      </nav>
    </div>
    <div>
      <NotificationStatistics v-if="currentRoute === 'statistics'" ref="statisticsRef" />
      <AllNotifications v-if="currentRoute === 'all'" ref="allNotificationsRef" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { nextTick, onMounted, ref } from "vue";
import AllNotifications from "./tabs/AllNotifications.vue";
import NotificationStatistics from "./tabs/NotificationStatistics.vue";

type TabRef = { refresh?: () => void } | null;

const currentRoute = ref("statistics");
const allNotificationsRef = ref<TabRef>(null);
const statisticsRef = ref<TabRef>(null);

const callRefresh = (tab: TabRef) => {
  tab?.refresh?.();
};

const select = (route: string) => {
  currentRoute.value = route;
  nextTick(() => {
    if (route === "all") callRefresh(allNotificationsRef.value);
    else if (route === "statistics") callRefresh(statisticsRef.value);
  });
};

onMounted(() => {
  nextTick(() => callRefresh(statisticsRef.value));
});
</script>
